<ng-container efpKeyboardShortcut (escShortcut)="closeModal()">
  <ng-content></ng-content>
</ng-container>
